import React from 'react';

const SectionDivider = () => {
  return (
    <div className="section-divider">
    </div>
  );
};

export default SectionDivider;